const DEFAULT_TRANSITION_NAME = 'trs-simple-fade';
const DEFAULT_TRANSITION_MODE = 'out-in';


export default {
    data() {
        return {
            routeTransition: {
                currentPage: null,
                toPage: null,
                fromPage: null,
            },
        };
    },
    computed: {
        routeTransitionAttrs() {
            let result = {
                name: DEFAULT_TRANSITION_NAME,
                mode: DEFAULT_TRANSITION_MODE,
            };

            switch (this.routeTransition.currentPage) {
                default:
                    break;
            }

            return result;
        },
    },
    methods: {
        afterRouteLeave() {
            this.routeTransition.currentPage = this.routeTransition.toPage;
            this.$root.$emit('root:trigger-scroll');
        },
        afterRouteEnter() {
            this.routeTransition.currentPage = null;
        },
    },
    watch: {
        $route: {
            handler(to, from) {
                this.transitionToPage = to.meta.currentPage;
                this.routeTransition.fromPage = from.meta.currentPage;

                this.routeTransition.currentPage = this.routeTransition.fromPage;
            },
        },
    },
};
